import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './InviteUserForm.module.css';
import ToggleInput from "../UI/ToggleInput";
import Input from "../CustomDropDown/Input/Input";
import Button1 from "../UI/Button/Button1";
import { inviteUser, UserPowerSearch } from "../../Api Methods/Api";
import { ListBox } from "primereact/listbox";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const userRoleReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};


const InviteExistingUserForm = ({ apiData, DeviceId, userID, userRole, userEmail, DeviceName, label, HandleCloseModal, HandleDeviceUserList, companyName, setUserAdded, setFailedToAdd, setFailMessage}, props) => {

    console.log(DeviceName);
    const [formIsValid, setFormIsValid] = useState(false);
    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    // UserRole Drop Down reducer  ----------------
    const [userRoleState, dispatchUserRole] = useReducer(userRoleReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showUserRoleDropDownOptions, selectedOption: selectedUserRoleOption } = userRoleState;

    const emailInputRef = useRef();
    const userRoleDropdownRef = useRef();

    const { isValid: emailIsValid } = emailState;
    const { isValid: userRoleIsValid } = userRoleState;

    const [userSuggestions, setUserSuggestions] = useState([]);
    const [stopSearch, setStopSearch] = useState(false)

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(emailIsValid && userRoleIsValid);
        }, 500);
    
        return () => {
            clearTimeout(identifier);
        };
    }, [emailIsValid, userRoleIsValid, emailState.value]);

    useEffect(() => {
        setStopSearch(false)
        const searchUser = async () => {
            const body = {
                "query": emailState.value || "",
                "portalAdmin": 0,
                "appAdmin": 0,
                "pageSize": 20,
                "pageOffset": 0
            }

            try {
                const users = await UserPowerSearch(apiData, body, dispatch);
                const userEmailAddresses = users?.[0]?.users?.map(user => user.email) ?? []
                setUserSuggestions(userEmailAddresses)
            } catch {
                setUserSuggestions([])
            }
        }

        const delayDebounceFn = setTimeout(() => {
            if (emailState.value !== '' && !stopSearch){
                searchUser()
            } else {
                setUserSuggestions([])
            } 
        }, 500);
        return () => clearTimeout(delayDebounceFn);

    }, [emailState.value])

    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }
    
    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    // Drop down handlers ---------------
    const handleUserRoleDropDownOnClick = () => {
        dispatchUserRole({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleUserRoleOptionChange = (option) => {
        dispatchUserRole({ type: 'SELECT_OPTION', payload: option });
    };
    const handleUserRoleBlur = () => {
        dispatchUserRole({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchUserRole({ type: 'INPUT_CLEAR', val: "" })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [startDateTime, setStartDateTime] = useState('')
    const [endDateTime, setEndDateTime] = useState('')
    const [isTemp, setIsTemp] = useState(false)
    const [appAdmin, setAppAdmin] = useState(false)


    const submitHandler = (event) => {
        event.preventDefault();

        if (formIsValid) {

            const email = emailState.value;
            let userRole = userRoleState.selectedOption;
            let liveViewAccess = 0

            if (userRoleState.selectedOption == "App manager"){
                userRole = "Manager"
            } else if (userRoleState.selectedOption == "App admin"){
                userRole = "Manager"
                appAdmin = 1
                liveViewAccess = 1
            } else if (userRoleState.selectedOption == "App manager plus"){
                userRole = "Manager"
                liveViewAccess = 1
            } else {
                userRole = "User"
            }

            inviteUser(apiData, DeviceId, userID, userRole, email, DeviceName, companyName, appAdmin == true? 1 : 0, liveViewAccess, startDateTime, endDateTime, isTemp, dispatch).then((responseData) => {

                if (responseData.success){
                    HandleCloseModal();
                    HandleDeviceUserList();
                    setUserAdded(true)
                } else {
                    setFailMessage(responseData.msg)
                    setFailedToAdd(true)
                }
            })

            onClearHandler();

            return;

        } else if (!emailIsValid) {
            emailInputRef.current.focus();
        } else if (!userRoleIsValid) {
            userRoleDropdownRef.current?.focus();
        }
    };

    const setSelectedEmail = (e) => {
        dispatchEmail({ type: 'USER_INPUT', val: e.value })
        setStopSearch(true)
        setUserSuggestions([])
    }
    
    return (
        <form autoComplete="off" onSubmit={submitHandler} className={classes["container"]} method="dialog" >
            <p style={{fontWeight:"500", fontSize:"16px", color:"#6e6e6e"}}>Search for an existing user by name or email.</p>
            <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", margin:"0px"}}>As you type, matching users already with an account will be suggested automatically.</p>
            <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", margin:"0px"}}>If no suggestion is made, that means there is no user account with this email, and pressing</p>
            <p style={{fontWeight:"500", fontSize:"14px", color:"#999797",  margin:"0px"}}>invite will invite that person to set up an account and also add them to this site.</p>

            <ul className={classes["inputs-list"]}>
                <li className={classes["input-container"]}>
                    <input
                        type="text"
                        name="fake-email"
                        autoComplete="email"
                        style={{ display: 'none' }}
                    />

<br/>
                    <Input
                        className={classes.input}
                        placeholder={"Enter user's email address"}
                        ref={emailInputRef}
                        id="Email"
                        type={"text"}
                        isValid={emailState.isValid}
                        value={emailState.value}
                        onChange={emailChangeHandler}
                        onBlur={validateEmailHandler}
                        name="email-no-autofill-123"
                        autoComplete="new-password"
                        readOnly
                        onFocus={(e) => e.target.removeAttribute('readonly')}
                    />

                    {userSuggestions.length > 0 && (
                        <div>
                            <ListBox 
                                value={emailState.value} 
                                onChange={setSelectedEmail} 
                                options={userSuggestions}
                                className="w-full md:w-14rem" 
                            />
                        </div>   
                    )}

                    <Dropdown
                        value={selectedUserRoleOption}
                        onChange={(e) => handleUserRoleOptionChange(e.value)}
                        options={['App standard user', 'App manager', 'App manager plus']}
                        placeholder="Select Role"
                        className="w-full"
                    />
                </li>


                <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setIsTemp(!isTemp)} checked={isTemp} name='Temporary access?'></Checkbox>
                    <label className="ml-2">   Temporary access</label>
                </div>

                <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setAppAdmin(!appAdmin)} checked={appAdmin} name='App admin?'></Checkbox>
                    <label className="ml-2">   Enable app admin</label>
                </div>
                

                {isTemp && 
                    <div className={classes["dateTime-container"]}>
                        {/* <p>From: </p>
                        <Calendar value={startDateTime} onChange={(e) => setStartDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" /> */}
                        <p>Until: </p>
                        <Calendar value={endDateTime} onChange={(e) => setEndDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" />
                    </div>
                }


                <div className={classes["button-container"]}>
                    <Button className={classes.submitButton} type="submit" label="Invite" severity="success" icon="pi pi-user-plus"/>
                </div>
            </ul>

        </form>


    )


}

export default InviteExistingUserForm;

